import { observable, ObservableObject } from '@legendapp/state';
import { createContext, useContext } from 'react';
import { BoundType, FocusCell } from './grid/types';

export const HeaderRowsContext = createContext<number>(0);

export const IntersectionObserverContext =
  createContext<IntersectionObserver | null>(null);

export const FocusCellContext = createContext<ObservableObject<FocusCell>>(
  observable<FocusCell>({ focusRow: -1, focusColumn: -1, editing: false }),
);

export function useFocusCell(): ObservableObject<FocusCell> {
  return useContext(FocusCellContext);
}

export const GridBoundsContext = createContext<ObservableObject<BoundType>>(
  observable<BoundType>({
    pos: { left: 0, top: 0 },
    bound: {
      row: { end: 0, start: 0 },
      column: {
        end: 0,
        start: 0,
      },
      actualRow: { end: 0, start: 0 },
    },
  }),
);

export function useGridBounds(): ObservableObject<BoundType> {
  return useContext(GridBoundsContext);
}
